import { render } from "./ReportGoodsReceipt.vue?vue&type=template&id=52245def&scoped=true"
import script from "./ReportGoodsReceipt.vue?vue&type=script&lang=js"
export * from "./ReportGoodsReceipt.vue?vue&type=script&lang=js"

import "./ReportGoodsReceipt.vue?vue&type=style&index=0&id=52245def&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52245def"]])

export default __exports__